import {
  AccessMemberGroupBadgeProps,
  ChannelBadgeProps,
  CompanyBadgeProps,
  LayerEditorsBadgeProps,
  EmailBadgeProps,
  RecipientBadgeProps,
} from './Types'
import { RecipientsSelectorValueType } from 'types'
import { getInitials } from 'utils'
import { UserBadge } from './UserBadge'
import { Badge } from './Badge'

const ChannelBadge = ({ recipient, ...props }: ChannelBadgeProps) => {
  const { name } = recipient
  return (
    <Badge type={RecipientsSelectorValueType.Channel} avatar={{ title: getInitials(name) }} title={name} {...props} />
  )
}

const AccessMemberGroupBadge = ({ recipient, ...props }: AccessMemberGroupBadgeProps) => {
  const { logo_url, label, name } = recipient
  return <Badge avatar={{ url: logo_url, title: getInitials(label) }} title={name} {...props} />
}

const EmailBadge = ({ recipient, ...props }: EmailBadgeProps) => {
  return <Badge avatar={{ title: getInitials(recipient) }} title={recipient} {...props} />
}

const CompanyBadge = ({ recipient, ...props }: CompanyBadgeProps) => {
  const { name, logo_url } = recipient
  return (
    <Badge
      type={RecipientsSelectorValueType.Company}
      avatar={{ url: logo_url, title: getInitials(name) }}
      title={name}
      {...props}
    />
  )
}

const LayerEditorsBadge = ({ recipient, ...props }: LayerEditorsBadgeProps) => {
  const { name } = recipient
  return (
    <Badge
      type={RecipientsSelectorValueType.LayerEditors}
      avatar={{ title: getInitials(name) }}
      title={name}
      {...props}
    />
  )
}

export const RecipientBadge = ({ recipient, ...props }: RecipientBadgeProps) => {
  switch (recipient.type) {
    case RecipientsSelectorValueType.User:
      return <UserBadge recipient={recipient.value} {...props} />
    case RecipientsSelectorValueType.Channel:
      return <ChannelBadge recipient={recipient.value} {...props} />
    case RecipientsSelectorValueType.Company:
      return <CompanyBadge recipient={recipient.value} {...props} />
    case RecipientsSelectorValueType.LayerEditors:
      return <LayerEditorsBadge recipient={recipient.value} {...props} />
    case RecipientsSelectorValueType.Email:
      return <EmailBadge recipient={recipient.value} {...props} />
    case RecipientsSelectorValueType.AccessMemberGroup:
      return <AccessMemberGroupBadge recipient={recipient.value} {...props} />
    default:
      return null
  }
}
